const HTML_ESCAPE_MAP: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
};

/**
 * Escapes HTML-significant characters so a user-provided string can be safely
 * interpolated into raw HTML (e.g. Highcharts `useHTML` labels). Prevents stored XSS.
 *
 * @param value - The raw string to escape.
 * @returns The string with `& < > " '` replaced by their HTML entities.
 */
export const escapeHtml = (value: string): string => String(value)
  .replace(/[&<>"']/g, (char) => HTML_ESCAPE_MAP[char]);

export default escapeHtml;
